import { FileMarkdownOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useState } from 'react';
import { utils, writeFile } from 'xlsx';

const BotonDescargaExcel = ({ data, filename }) => {
  const [loading, setLoading] = useState(false);
  const date = new Date().toLocaleDateString();

  const exportToExcel = () => {
    console.log('Exportando a Excel');

    // Se eliminan aquellos cuyo campo sea un objeto
    const filteredData = data.map((item) => {
      const newItem = { ...item };
      Object.keys(newItem).forEach((key) => {
        if (typeof newItem[key] === 'object') {
          delete newItem[key];
        }
      });

      if (newItem.tieneAnexos) {
        newItem.tieneAnexos = 'Si';
      } else {
        newItem.tieneAnexos = 'No';
      }

      delete newItem.key;

      return newItem;
    });

    setLoading(true);

    const templateData = [];

    // Se obtiene el nombre de las columnas
    templateData.push(Object.keys(filteredData[0]));

    // Se obtiene los valores de las columnas
    filteredData.forEach((element) => {
      templateData.push(Object.values(element));
    });

    const worksheet = utils.aoa_to_sheet(templateData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, filename);
    writeFile(workbook, `${filename}-${date}.xlsx`);
    setLoading(false);
  };

  return (
    <Button
      type="primary"
      disabled={data.length === 0}
      loading={loading}
      style={{ marginLeft: '10px' }}
      onClick={exportToExcel}>
      Exportar a Excel
      <FileMarkdownOutlined />
    </Button>
  );
};

export default BotonDescargaExcel;
